import React from 'react';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { FormControl, FormHelperText } from 'material-ui/Form';
import DateTime from 'react-datetime';
const createReactClass = require('create-react-class');
const enhanceWithClickOutside = require('react-click-outside');


const DateTimeField = createReactClass({

   getInitialState() {
    return {
      open: false,
    };
   },

  changeVisibility(status) {
    this.setState({ open: status })
  },

  handleClickOutside(e) {
    let elements = [];
    if (e.path) {
      elements = e.path.slice(0, 5);
    } else {
      let element = e.target;
      for (var i = 0; i < 5; i++) {
        element = element.parentElement;
        elements.push(element);
      }
    }

    const rtdElement = elements.find(e => e.classList.value.match(/rdt[A-Z]/));
    if(!rtdElement)
      this.changeVisibility(false);
  },

  render() {
    const {
      className,
      onChange,
      value,
      field_name,
      label,
      errors
    } = this.props;
    return (
      <div className={className} style={{ width: '100%', marginTop: '25px'}}
           onClick={() => this.changeVisibility(true)}>
           <DateTime
             disableOnClickOutside={true}
             value={value}
             onChange={(value) => onChange(field_name, value)}
             open={this.state.open}
             dateFormat={'D/M/YYYY'}
           />
        <FormHelperText id="weight-helper-text" error={(errors && errors.length)}>
          {label}{errors && errors.length && `: `} {(errors || [])[0]}
        </FormHelperText>
      </div>
    );
  }
});

DateTimeField.defaultProps = {};

DateTimeField.propTypes = {};

export default enhanceWithClickOutside(DateTimeField);



/** WEBPACK FOOTER **
 ** ./src/components/InputField/DateTimeField.jsx
 **/